import { render, staticRenderFns } from "./IngresosMPListado.vue?vue&type=template&id=32e85d0e&"
import script from "./IngresosMPListado.vue?vue&type=script&lang=js&"
export * from "./IngresosMPListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports